// src/Services/api_endpoints.js

//export const baseURL = "https://rndsan.com/"; 
// SWITCH TO LOCAL HOST AS PER YOUR POSTMAN TEST
//export const baseURL = "http://192.168.29.250:7000/"; 
//export const baseURLImg = "http://192.168.29.250:7000"
export const  baseURLImg= "https://admin-service.swasthyakhata.com/admin"

export const  baseURL= "https://admin-service.swasthyakhata.com/"

// login endpoint
export const login = {
  login: baseURL + "admin/login",
  admin_create: baseURL + "admin/create-admin",
  get_profile:baseURL+'admin/get-admin-profile',
  forget_password:baseURL+'admin/forgot-password',
  reset_password:baseURL+'admin/reset-password',
  updateProfile:baseURL+'admin/update-admin-profile'
};

export const listData={
  all_hospitals:baseURL+'admin/get-all-hospitals',
  all_doctors:baseURL+'admin/get-all-doctors',
  all_diagnostics:baseURL+'admin/diagnostic-centers',
  all_music:baseURL+'admin/get-all-music',
  uploadMusic:baseURL+'admin/upload-music'
}
